import React, { useEffect, useState } from 'react'
import './Dash.css'
import Chart from "react-apexcharts";
import { useTheme } from '../theme/ThemeContext';
import axios from 'axios';
import LoadingSpinner from '../Loading/LoadingSpinner';
import NotificationPopup from '../alertpopup/NotificationPopup';
const Dash = () => {
  const token = localStorage.getItem('authToken')
  const { theme } = useTheme()
  
  const backendurl = window.location.hostname === 'localhost'
    ? ''
    : window.location.hostname === 'demo.ollinwon.com'
      ? process.env.REACT_APP_BACKEND_URL
      : window.location.hostname === 'iot.aizoteq.com'
        ? process.env.REACT_APP_BACKEND_URL2
        : '';
  
  const [stock, setStock] = useState(null);
  const [userData, setUserData] = useState({});
  const [chartData, setChartData] = useState({ options: {}, series: [] });
  const [salechartData, setSaleChartData] = useState({ options: {}, series: [] });
  const [error, setError] = useState(null);
  const [groupBy, setGroupBy] = useState("day");
  const [salegroupBy, setSaleGroupBy] = useState("day");
  const [salesCount, setSalesCount] = useState(null);
  
  // Loading states
  const [loading, setLoading] = useState({
    stock: true,
    user: true,
    thing: true,
    sales: true,
    chart: true,
    saleChart: true,
    userData: true
  });

  // Notification state
  const [notification, setNotification] = useState({
    show: false,
    type: "success",
    message: "",
    title: ""
  });

  // Notification helper function
  const showNotification = (type, message, title = "", duration = 3000) => {
    setNotification({
      show: true,
      type,
      message,
      title
    });
    
    setTimeout(() => {
      setNotification(prev => ({ ...prev, show: false }));
    }, duration);
  };

  // Notification Popup Component
 

  useEffect(() => {
    const fetchStock = async () => {
      try {
        const response = await axios.get(`${backendurl}/api/adminstock/new/count`, {
          headers: {
            'Authorization': ` Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        });
        setStock(response.data.count);
      } catch (err) {
        console.error('Error fetching stock data:', err);
        showNotification("error", "Failed to load stock data", "Load Error");
      } finally {
        setLoading(prev => ({ ...prev, stock: false }));
      }
    };

    fetchStock();
  }, []);

  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`${backendurl}/dashboard/api/users/count`, {
          headers: {
            'Authorization': ` Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        });
        setUser(response.data.user_count);
      } catch (err) {
        console.error('Error fetching user count:', err);
        showNotification("error", "Failed to load user count", "Load Error");
      } finally {
        setLoading(prev => ({ ...prev, user: false }));
      }
    };

    fetchUser();
  }, []);

  const [thing, setThing] = useState(null);

  useEffect(() => {
    const fetchThing = async () => {
      try {
        const response = await axios.get(`${backendurl}/dashboard/api/things/count`);
        setThing(response.data.total_count);
      } catch (err) {
        console.error('Error fetching thing count:', err);
        showNotification("error", "Failed to load thing count", "Load Error");
      } finally {
        setLoading(prev => ({ ...prev, thing: false }));
      }
    };

    fetchThing();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${backendurl}/dashboard/api/production/graph?groupBy=${groupBy}`, {
          headers: {
            'Authorization': ` Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch production data");
        }
        const data = await response.json();

        setChartData({
          options: {
            chart: {
              type: "area",
              zoom: { enabled: false },
            },
            xaxis: {
              categories: data.data.map(item => item.period),
            },
            title: { text: `Product Data (${groupBy})` },
          },
          series: [
            {
              name: "Thing Count",
              data: data.data.map(item => item.thing_count),
            },
          ],
        });
      } catch (err) {
        setError(err.message);
        showNotification("error", "Failed to load production chart", "Load Error");
      } finally {
        setLoading(prev => ({ ...prev, chart: false }));
      }
    };

    setLoading(prev => ({ ...prev, chart: true }));
    fetchData();
  }, [groupBy]);

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        const response = await fetch(`${backendurl}/dashboard/api/sales/graph?groupBy=${salegroupBy}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch sales data");
        }

        const data = await response.json();

        let salesData = [];
        let categories = [];

        salesData = data.sales_data.map((item) => item.total_sales);
        categories = data.sales_data.map((item) => item.period);

        setSaleChartData({
          options: {
            chart: { type: "bar", zoom: { enabled: false } },
            xaxis: { categories },
            title: { text: `Sales Data (${salegroupBy})` },
          },
          series: [{ name: "Total Sales", data: salesData }],
        });
      } catch (err) {
        setError(err.message);
        showNotification("error", "Failed to load sales chart", "Load Error");
      } finally {
        setLoading(prev => ({ ...prev, saleChart: false }));
      }
    };

    setLoading(prev => ({ ...prev, saleChart: true }));
    fetchSalesData();
  }, [salegroupBy]);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${backendurl}/api/display/user`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
      } else {
        console.error("Failed to fetch user data.");
        showNotification("warning", "Failed to load user profile", "Load Warning");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      showNotification("error", "Error loading user profile", "Network Error");
    } finally {
      setLoading(prev => ({ ...prev, userData: false }));
    }
  };

  useEffect(() => {
    const fetchSalesCount = async () => {
      try {
        const response = await fetch(`${backendurl}/dashboard/api/sales/count`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Authorization': ` Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          setSalesCount(data.total_sales);
        } else {
          console.error("Error fetching sales count:", data.error);
          showNotification("warning", "Failed to load sales count", "Load Warning");
        }
      } catch (error) {
        console.error("Error:", error);
        showNotification("error", "Error loading sales count", "Network Error");
      } finally {
        setLoading(prev => ({ ...prev, sales: false }));
      }
    };

    fetchSalesCount();
  }, []);

  // Check if any loading is still happening
  const isLoading = Object.values(loading).some(value => value === true);

  return (
    <div className={`dash-main ${theme}-theme`}>
      {/* Show fullscreen loading spinner if any data is loading */}
      {/* {isLoading && (
        // < LoadingSpinner
        //   // fullScreen={true} 
        //   text="Loading dashboard data..."
        //   color={theme === "dark" ? "primary" : "primary"}
        // />
      )} */}
      
      {/* Show notification popup */}
      <NotificationPopup
        show={notification.show}
        type={notification.type}
        message={notification.message}
        title={notification.title}
        onClose={() => setNotification({ ...notification, show: false })}
        duration={5000}
      />
      
      <div className="dash-dummy"></div>
      <div className="dash-content-main">
        <div className="dash-content-card">
          {/* Users Card */}
          <div className="dash-card">
            <div className="dash-card-content-main">
              <div className="dash-card-content-head">
                <p>Users</p>
              </div>
              <div className="dash-card-content-count">
                <i className="fa-solid fa-user"></i>
                {loading.user ? (
                  <div style={{ marginLeft: '10px' }}>
                    <LoadingSpinner size="small" color="primary" />
                  </div>
                ) : (
                  <p>{user !== null ? user : 'Error'}</p>
                )}
              </div>
              <div className="dash-card-content-last">
                <p>18% Higher Than Last Month</p>
              </div>
            </div>
          </div>

          {/* Thing Card */}
          <div className="dash-card">
            <div className="dash-card-content-main">
              <div className="dash-card-content-head">
                <p>Thing</p>
              </div>
              <div className="dash-card-content-count">
                <i className="fa-solid fa-business-time"></i>
                {loading.thing ? (
                  <div style={{ marginLeft: '10px' }}>
                    <LoadingSpinner size="small" color="primary" />
                  </div>
                ) : (
                  <p>{thing !== null ? thing : 'Error'}</p>
                )}
              </div>
              <div className="dash-card-content-last">
                <p>18% Higher Than Last Month</p>
              </div>
            </div>
          </div>

          {/* Sale Card */}
          <div className="dash-card">
            <div className="dash-card-content-main">
              <div className="dash-card-content-head">
                <p>Sale</p>
              </div>
              <div className="dash-card-content-count">
                <i className="fa-solid fa-chart-line"></i>
                {loading.sales ? (
                  <div style={{ marginLeft: '10px' }}>
                    <LoadingSpinner size="small" color="primary" />
                  </div>
                ) : (
                  <p>{salesCount !== null ? salesCount : 'Error'}</p>
                )}
              </div>
              <div className="dash-card-content-last">
                <p>18% Higher Than Last Month</p>
              </div>
            </div>
          </div>

          {/* Stock Card */}
          <div className="dash-card">
            <div className="dash-card-content-main">
              <div className="dash-card-content-head">
                <p>Stock</p>
              </div>
              <div className="dash-card-content-count">
                <i className="fa-solid fa-chart-line"></i>
                {loading.stock ? (
                  <div style={{ marginLeft: '10px' }}>
                    <LoadingSpinner size="small" color="primary" />
                  </div>
                ) : (
                  <p>{stock !== null ? stock : 'Error'}</p>
                )}
              </div>
              <div className="dash-card-content-last">
                <p>18% Higher Than Last Month</p>
              </div>
            </div>
          </div>
        </div>

        <div className="dash-chart-main">
          {/* Production Chart */}
          <div className="dash-chart-content">
            <div className="dash-chart-head">
              <p>Product Chart</p>
              <div className="dropdown-container">
                <select 
                  onChange={(e) => setGroupBy(e.target.value)} 
                  value={groupBy} 
                  className="dropdown-menu"
                  disabled={loading.chart}
                >
                  <option value="day">Day</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
            </div>

            <div className="dash-chart-1">
              {loading.chart ? (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  height: '300px',
                  width: '100%'
                }}>
                  <LoadingSpinner size="medium" text="Loading production chart..." color="primary" />
                </div>
              ) : error ? (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  height: '300px',
                  color: theme === 'dark' ? '#e74c3c' : '#c0392b'
                }}>
                  <p>{error}</p>
                </div>
              ) : (
                <Chart 
                  options={chartData.options} 
                  series={chartData.series} 
                  type="area" 
                  width="100%" 
                  height="120%" 
                />
              )}
            </div>
          </div>

          {/* Sales Chart */}
          <div className="dash-chart-content">
            <div className="dash-chart-head">
              <p>Sale Chart</p>
              <div className="dropdown-container">
                <select 
                  onChange={(e) => setSaleGroupBy(e.target.value)} 
                  value={salegroupBy} 
                  className="dropdown-menu"
                  disabled={loading.saleChart}
                >
                  <option value="day">Day</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
            </div>

            <div className="dash-chart-1">
              {loading.saleChart ? (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  height: '300px',
                  width: '100%'
                }}>
                  <LoadingSpinner size="medium" text="Loading sales chart..." color="primary" />
                </div>
              ) : error ? (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  height: '300px',
                  color: theme === 'dark' ? '#e74c3c' : '#c0392b'
                }}>
                  <p>{error}</p>
                </div>
              ) : (
                <Chart 
                  options={salechartData.options} 
                  series={salechartData.series} 
                  type="bar" 
                  width="100%" 
                  height="120%"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dash;